export enum PartnerExcelImportFileType {
    UNKNOWN = 0,
    DATEV_MASTER = 100,
    DATEV_ACCOUNTS = 110,
    BEXIO_MASTER = 200,
    BEXIO_ACCOUNTS = 210,
}
